document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);
  const utm_medium = params.get('utm_medium') || 'organico';
  const utm_campaign = params.get('utm_campaign') || '';

  const tracking = `[${utm_medium}${utm_campaign ? '/' + utm_campaign : ''}]`;

  document.querySelectorAll('.wa-cta').forEach(function (btn) {
    const currentHref = btn.getAttribute('href');
    if (!currentHref) return;
    const url = new URL(currentHref, window.location.origin);
    const existingText = url.searchParams.get('text');
    url.searchParams.set('text', existingText ? `${existingText} ${tracking}` : tracking);
    btn.setAttribute('href', url.toString());
  });
});
